import ProductPriceFormat from '../../products/product-price/product-price-format';
import { useAppSelector } from '../data/store';

const AddedCartItemPrices = () => {

    const addedCartItem = useAppSelector(store => store.root.addedCartItem);
    const addedCartItemAdditionalData = useAppSelector(store => store.root.addedCartItemAdditionalData);
    const couponPrice = addedCartItemAdditionalData?.couponPrice ?? 0;
    const couponCode = addedCartItemAdditionalData?.couponCode || '';
    // const discount = addedCartItemAdditionalData?.discount ?? 0;

    const withCouponEnabled = !!addedCartItemAdditionalData && addedCartItemAdditionalData?.couponCampaignID > 0;
    const isWithCoupon = withCouponEnabled && couponPrice > 0;
    const isSamePrice = addedCartItem?.skU_MSRP === addedCartItem?.skuPrice;

    return (
        <>
            {
                addedCartItem &&
                <div className="flex flex-col">
                    {/* prices row #1: different prices / with coupon */}
                    {
                        (couponPrice > 0 || !isSamePrice) &&
                        <div className="flex items-center">

                            {/* MSRP price */}
                            <div className="text-sm text-gray-500 mr-2">
                                <s aria-hidden="true"><ProductPriceFormat price={addedCartItem.skU_MSRP} accessible={false}/></s>
                                <span className="sr-only">Full Price ${addedCartItem.skU_MSRP}</span>
                            </div>

                            {/* on sale: sku price if 'with coupon' price exists */}
                            {
                                (couponPrice > 0 && !isSamePrice) &&
                                <div className="text-sm text-gray-500">
                                    <ProductPriceFormat price={addedCartItem.skuPrice}/>
                                </div>
                            }
                        </div>
                    }

                    {/* prices row #1: same price */}
                    {
                        (isSamePrice && couponPrice <= 0) &&
                        <div className="flex items-center text-base text-gray-500">Now</div>
                    }

                    {/* prices row #2 */}
                    <div className="flex items-center">

                        {/* main price: if 'with coupon' exists -> 'with coupon' price, otherwise sku price */}
                        <div className="text-sm font-bold text-gray-700 mb-1">
                            {
                                isWithCoupon &&
                                <span>
                                    <ProductPriceFormat price={ couponPrice } /> &nbsp;
                                    <span className="sr-only">
                                        With Coupon:<br/> <span>{ couponCode }</span>
                                    </span>
                                </span>
                            }

                            {!isWithCoupon && <ProductPriceFormat price={addedCartItem.skuPrice}/>}
                        </div>

                        {/* discount red tag */}
                        {/*{
                            discount > 0 &&
                            <DiscountBadge discount={ discount } />
                        }*/}
                    </div>

                    {/* prices row #3 */}
                    {
                        couponCode &&
                        <div className="flex items-center text-sm">
                            <div className="text-sm text-gray-700 font-bold" aria-hidden={true}>With Coupon:<br/> <span>{ couponCode }</span></div>
                        </div>
                    }

                    {/*{
                        addedCartItem.saleEndDate &&
                        <div className="mt-4">
                            <ProductClock saleEndDate={new Date(addedCartItem.saleEndDate)}/>
                        </div>
                    }*/}
                </div>
            }
        </>
    )
};

export default AddedCartItemPrices;